import { Mapper } from "../../../../base/utils/mapper";
import { VitalSignsMedicalResponseModel } from "../../../../domain/models/consult/vital-signs-medical.response.model";
import { VitalSignsMedicalResponseEntity } from "../entities/vital-signs-medical-response.entity";



export class VitalSignsMedicalImplementationRepositoryMapper extends Mapper<VitalSignsMedicalResponseEntity, VitalSignsMedicalResponseModel> {
    mapFrom(param: VitalSignsMedicalResponseEntity): VitalSignsMedicalResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: VitalSignsMedicalResponseModel): VitalSignsMedicalResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}